const categories = (state) => state.categories;

export default categories;
